import { SALES_DATA } from '../../constants/ActionTypes';

const INIT_STATE = {
  salesperson: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SALES_DATA: {
      return {
        ...state,
        salesPerson: action.payload,
      };
    }

    default:
      return state;
  }
};
